import * as React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { NavigationLink } from "types";
import * as styles from "./styles";
import { classes } from "typestyle";

interface IProps {
  links: NavigationLink[];
}

const Tabs: React.FC<IProps> = ({ links }) => {
  const location = useLocation();

  return (
    <div className={styles.tabs}>
      <div className={styles.tabGroup}>
        {links
          .filter((link) => link.position === "left")
          .map((link) => (
            <NavLink
              key={link.to}
              end={link.exactMatch}
              className={(isActive) =>
                classes(styles.link, location.pathname === link.to && styles.active)
              }
              to={link.to}
            >
              {link.text}
            </NavLink>
          ))}
      </div>
      <div>
        {links
          .filter((link) => link.position === "right")
          .map((link) => (
            <NavLink
              key={link.to}
              end={link.exactMatch}
              className={(isActive) =>
                classes(styles.link, location.pathname === link.to && styles.active)
              }
              to={link.to}
            >
              {link.text}
            </NavLink>
          ))}
      </div>
    </div>
  );
};

export default Tabs;
